import { ApplicationConfig, importProvidersFrom, Injectable, isDevMode, LOCALE_ID } from '@angular/core';
import { RouterModule, provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, provideHttpClient } from '@angular/common/http';
import { provideTransloco } from '@ngneat/transloco';
import { TranslocoHttpLoader } from './transloco-loader';
import { AVAILABLE_LANGUAGES, LANGUAGE_BY_DEFAULT } from '@shared/models';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { NgxMatTimepickerLocaleService, NgxMatTimepickerModule } from 'ngx-mat-timepicker';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { CustomDateAdapter } from './custom-date-adapter';

registerLocaleData(localeEs, 'es-ES');
const language = navigator.language;
const languageCode = language.split('-')[0];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    importProvidersFrom(BrowserModule),
    importProvidersFrom(Clipboard),
    importProvidersFrom(MatSnackBarModule),
    importProvidersFrom(NgxMatTimepickerModule),
    importProvidersFrom(NgxMatTimepickerLocaleService),
    { provide: DateAdapter, useClass: CustomDateAdapter},
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES'},
    { provide: LOCALE_ID, useValue: 'es-ES'},
    importProvidersFrom(RouterModule.forRoot(routes)),
    importProvidersFrom(HttpClientModule),
    importProvidersFrom(BrowserAnimationsModule),
    provideAnimations(), provideHttpClient(), provideTransloco({
      config: { 
        availableLangs: AVAILABLE_LANGUAGES,
        defaultLang: AVAILABLE_LANGUAGES.includes(languageCode) ? languageCode : LANGUAGE_BY_DEFAULT,
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader
    })
  ]
};
